/* Results (sections/st-results.liquid): when a card comes into view its review count runs up from 0
   (ease-out quart, about 2s for the big one, a little less for the small) and its bar grows from
   the left (CSS, on .is-run). Runs once. Under reduced motion, or without IntersectionObserver,
   nothing is changed: the final numbers and full bars are already in the HTML. */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  const fmt = new Intl.NumberFormat(document.documentElement.lang || 'en-US');
  const count = (el, to, dur) => {
    let t0 = null;
    const step = (t) => {
      if (t0 === null) t0 = t;
      const k = Math.min(1, (t - t0) / dur);
      el.textContent = fmt.format(Math.round(to * (1 - Math.pow(1 - k, 4))));
      if (k < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  const init = (section) => {
    if (section.dataset.stResultsReady) return;
    section.dataset.stResultsReady = '1';
    const cards = [...section.querySelectorAll('.st-res__card')];
    const vh = window.innerHeight;
    cards.forEach((card) => {
      if (card.getBoundingClientRect().top < vh) return; // already on screen: leave it at rest
      card.classList.add('is-armed');
      const n = card.querySelector('[data-st-count]');
      if (n) n.textContent = '0';
    });
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => {
          if (!en.isIntersecting) return;
          io.unobserve(en.target);
          const card = en.target;
          const i = cards.indexOf(card);
          card.classList.add('is-run');
          const n = card.querySelector('[data-st-count]');
          const to = Number(n?.dataset.stCount || 0);
          if (n) setTimeout(() => count(n, to, to > 100 ? 2200 : 1600), 250 + i * 150);
        });
      },
      { threshold: 0.3, rootMargin: '0px 0px -8% 0px' }
    );
    cards.filter((c) => c.classList.contains('is-armed')).forEach((c) => io.observe(c));
  };
  const run = () => document.querySelectorAll('[data-st-results]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
